enum LoadingState {
    Done,
    Loading,
    Unauthorized,
    Error,
}

export default LoadingState;
